import { useContext, useEffect, useState } from 'react';
import UserContext from '../context/UserContext';
import { getPlanInfo } from '../services/client';
import { saveUserInfoInLocalStorage } from '../services/auth';

const useCheckPlan = () => {
  const { plan, setPlan } = useContext(UserContext);
  const [incomingPlan, setIncomingPlan] = useState(null);
  
  useEffect(() => {
    const fetchPlanInfo = async () => {
      try {
        const res = await getPlanInfo();        
        saveUserInfoInLocalStorage(res.data);    
        setPlan(res.data)
      } catch (error) {
        console.error('Error al obtener información del plan:', error);
      }
    };
    
    if (incomingPlan && incomingPlan !== plan?.info?.plan) {      
      fetchPlanInfo();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [incomingPlan, plan]);
  return { setIncomingPlan };
};

export default useCheckPlan;
